/**************************************************************************************************/
/*   File: /src/app/shared/models/spatial.data.content.ts                                         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 1st 2019                                                          */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 01 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LocalDocumentId } from './local.document.id';
import { SpatialDataTypeEnum } from '../enums';
/**
 * The spatial data content
 */
export class SpatialDataContent {
    /**
     * The dossier id
     */
    dossierId: number;
    /**
     * The spatial data document id
     */
    spatialData: LocalDocumentId;
    /**
     * The spatial data type 
     */
    spatialDataType: SpatialDataTypeEnum;
}